import { render, staticRenderFns } from "./send-code-btn.vue?vue&type=template&id=76f3bab4&scoped=true&"
import script from "./send-code-btn.vue?vue&type=script&lang=js&"
export * from "./send-code-btn.vue?vue&type=script&lang=js&"
import style0 from "./send-code-btn.vue?vue&type=style&index=0&id=76f3bab4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f3bab4",
  null
  
)

export default component.exports